/**
 * Returns the backend URL based on current environment.
 */
export function getBackendUrl() {
  // Development
  if (window.location.hostname === "localhost") {
    return "http://localhost:8000";
  }
  // Production — same domain, /api prefix routed to backend via Traefik
  return "/api";
}
